import { imageLightboxes } from '../components/image-lightbox'

export default {
  init() {
   
    imageLightboxes()

  },
}


// WEBPACK FOOTER //
// ./scripts/routes/single-bespoke-services.js